export default __webpack_public_path__ + "static/media/05.6ce04bed.jpg";